import React, { Fragment } from 'react'
import { useDispatch } from 'react-redux'
import { host } from '../../../configuraciones';
import ModalMensajeComponent from '../../App/ModalMensajeComponent';
import GetAppIcon from '@mui/icons-material/GetApp';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import { IconButton } from '@mui/material';
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../redux/AppDucks';

function BotonDescargarZipComponent(props) {
    const dispatch = useDispatch()
    const [openModal, setOpenModal] = React.useState(false)
    const downloadSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        let url = ''
        if (props?.data.tipo == 'Cliente') {
            url = await `InformacionCliente/servirSegumiento/nameTabla=${'ocsolicitudfc01_seguimiento'}&nameFK=${'idsolicitudesocfc01'}&idSolicitud=${props?.data?.idsolicitudesocfc01}`
        }
        const fileFetch = await fetch(host + `${url}`,{
            method: 'GET',
            headers:{
                'authorization':localStorage.getItem('user'),
                'refresh-authorization': localStorage.getItem('refreshToken'),
                'Content-Type': 'application/json'
            },
        })
        await dispatch(actualizarLoadingApp_false())
        if(fileFetch.status != 404){
            const blob = await fileFetch.blob();
            const url = window.URL.createObjectURL(new Blob([blob]), { type: 'application/zip' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${'Seguimiento'}.zip`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }else {
            setOpenModal(true)
        }
    }

    return (
        <Fragment>
            <IconButton onClick={() => downloadSolicitud()}>
                <FolderZipIcon sx={{ color: '#31549a', width: '100%' }}></FolderZipIcon>
            </IconButton>
            {
                openModal &&
                <ModalMensajeComponent setOpenModal={{ setOpenModal }} titleModal={'Error'} bodyModal={'No hay archivos adjuntos'}></ModalMensajeComponent>
            }
        </Fragment>
    )
}

export default BotonDescargarZipComponent